// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--21j1P","orange":"orange--3QVWb","blue":"blue--18NOr","title":"title--1-4-T"};